<template>
  <div>
    <div class="text-sm-right">
      <img id="logoLogin" :src="serverUrl + '/images/'+logo" />
    </div>

    <languageSelector :addContainer="true"/>

    <v-form @submit.prevent="login" ref="form" lazy-validation>
      <v-text-field
        :label="$t('Email')"
        v-model="email"
        required
        :rules="[(v) => !!v || $t('Email is required'),(v) => /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(v) || $t('Email must be valid')]"
        validate-on-blur
      ></v-text-field>

      <v-text-field
        :label="$t('Password')"
        v-model="pass"
        type="password"
        required
        :rules="[(v) => !!v || $t('Password is required'),(v) => v && v.length > 4 || $t('Password is too short')]"
        validate-on-blur
      ></v-text-field>

      <div class="text-sm-right">
        <v-btn type="submit" :loading="loading" class="ml-0 mr-0" color="primary">{{$t('Login')}}</v-btn>
      </div>

      <v-alert class="mt-3" id="login-error" v-if="error.length > 0" color="error" icon="warning" :value="true">
          {{ error }}
      </v-alert>
    </v-form>

    <p class="text-sm-right mt-3">
      <router-link to="/forgotpassword">
        {{ $t('Forgot password?') }}
      </router-link>
    </p>
  </div>

</template>

<script>
import Vue from 'vue'
import auth from '../../auth'
import config from '../../config'
import helpers from '../../helpers'

export default {
  data () {
    return {
      email: '',
      pass: '',
      error: '',
      loading: false,
      logo: config.logoPos,
      serverUrl: helpers.getServerUrl()
    }
  },
  methods: {
    login () {
      if (this.$refs.form.validate()) {
        this.loading = true

        auth.login(this.email, this.pass, res => {
          this.loading = false
          if (!res.success) {
            this.error = res.message
            this.pass = ""
          } else {
            Vue.i18n.set(res.data.Language)

            this.$router.go(-1)
          }
        })
      }
    }
  }
}
</script>

<style>
  #login-container{
    max-width:550px;
  }

  #logoLogin{
    max-width:60%;
    width:100%;
    margin:10px 0;
  }
</style>
